<template>
    <div class="row-path"
         :id="row_path_id"
         :class="classBreadCrumb"
    >
        <!--left side-->
        <ul class="path">
            <li>
                <router-link :to="{name:'Home'}" class="path-home">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" class="fill-primary" >
                        <g id="Mask">
                            <polygon id="path-1_1_" points="32,74 32,50 48,50 48,74 68,74 68,42 80,42 40,6 0,42 12,42 12,74 	"/>
                        </g>
                        <polygon id="path-1"  points="32,74 32,50 48,50 48,74 68,74 68,42 80,42 40,6 0,42 12,42 12,74 "/>
                    </svg>
                </router-link>
            </li>
            <template v-if="main_cate_title">
                <li class="path-arrow">
                    <svg version="1.1" id="圖層_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     width="80px" height="80px" viewBox="0 0 80 80" enable-background="new 0 0 80 80" xml:space="preserve">
                    <path d="M28.078,1.423c-1.921-1.897-3.836-1.897-5.745,0.001c-1.909,1.899-2.867,2.852-2.873,2.858
                        c-1.946,1.874-1.947,3.778-0.001,5.712C21.404,11.93,31.46,21.93,49.627,39.996L19.458,69.999c-1.916,1.905-1.916,3.81,0,5.714
                        c1.939,1.93,2.896,2.881,2.873,2.859c1.916,1.904,3.831,1.904,5.747,0c1.966-1.957,12.979-12.91,33.041-32.86
                        c3.841-3.8,3.841-7.608,0-11.43C59.201,32.375,48.188,21.421,28.078,1.423z"/>
                </svg>
                </li>
                <li class="main-cate-title">{{ replaceBr(main_cate_title) }}</li>
            </template>
            <template v-if="sub_cate_title">
                <li class="path-arrow">
                    <svg version="1.1" id="圖層_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     width="80px" height="80px" viewBox="0 0 80 80" enable-background="new 0 0 80 80" xml:space="preserve">
                    <path d="M28.078,1.423c-1.921-1.897-3.836-1.897-5.745,0.001c-1.909,1.899-2.867,2.852-2.873,2.858
                        c-1.946,1.874-1.947,3.778-0.001,5.712C21.404,11.93,31.46,21.93,49.627,39.996L19.458,69.999c-1.916,1.905-1.916,3.81,0,5.714
                        c1.939,1.93,2.896,2.881,2.873,2.859c1.916,1.904,3.831,1.904,5.747,0c1.966-1.957,12.979-12.91,33.041-32.86
                        c3.841-3.8,3.841-7.608,0-11.43C59.201,32.375,48.188,21.421,28.078,1.423z"/>
                </svg>
                </li>
                <li>{{ replaceBr(sub_cate_title) }}</li>
            </template>

        </ul>
        <!--right side-->
        <!--content on the right hand side start-->
        <div class="row-path-right">
            <div class="right-element">
                <!-- search result slot, with default content-->
                <slot name="search-result">
                   <div class="search-result text-secondary"
                        v-show="total_resources>0"
                   >
                       {{ lang($t("Total %total_resources% Resource(s)"),{total_resources: total_resources} ) }}

                   </div>
                </slot>
            </div>
            <div class="right-element" v-show="isShowFilter">
                <!-- filter button slot, with default content-->
                <slot name="filter-control" class="right-element" >
                    <!-- //TODO: Consider to get rid of using refs... -->
                    <sub-cate-filter ref="subCateFilter" ></sub-cate-filter>
                </slot>
            </div>
        </div>
        <!--content on the right hand side end-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import EventBus from '@common/eventBus';

    export default {
        name: "Breadcrumb",
        mixins:[common,storeMapper],
        props: {
            main_cate_title: {
                default: "",
                type: String
            },
            sub_cate_title: {
                default: "",
                type: String
            },
            total_resources: {
                default:0,
                type:Number
            },
            /*
            cate_bg_color: {
                default:'#000',
                type:String
            },
            */
            isShowFilter: {
                default:false,
                type:Boolean
            }
        },
        watch: {
            '$route' (to, from) {
                this.$refs.subCateFilter.closeFilter();
            }
        },
        data() {
            return {
                mainAppOffsetTop: null, //the #app element offsetTop, used for determining if sticking hte breadcrumb to window top or not
                row_path_id: "row_path",
                menuStatus:null
            }
        },
        mounted() {
            window.addEventListener('scroll', (event) => {
                //Note we can't use window.scrollY to determine scroll offset directly since after the breadcrumb has changed to 'position:fixed', it loses its height,
                //and so the classBreadCrumb will keep changing!
                this.mainAppOffsetTop = document.querySelector("#app").getBoundingClientRect().top
            });

            EventBus.$on("onMenuEnter", ()=> {
                this.menuStatus="enter";
            });

            EventBus.$on("onMenuLeave", ()=> {
                this.menuStatus="leave";
            });
        },
        computed: {
            classBreadCrumb() {
                return {
                    'stick-to-top': (this.mainAppOffsetTop < -150 &&  this.menuStatus !== "enter" && this.$mq === "wide" ) ? true: false
                }
            }
            /*
            styleCateTitle() {
                return {
                    'color': this.cate_bg_color
                }
            }
            */
        },
        methods: {

            replaceBr(text)
            {

                return text.replace("<br>", "");
            }
        }
    }
</script>

<!-- Note we use slot in template, so set style not scoped-->
<style lang="scss">

    @import "~@sass/_variables.scss";
    @import "~@sass/_mixins.scss";

    .stick-to-top {
        position: fixed;
        z-index: 10;
        left: 0;
        top:0;
        padding: 1rem 1.5rem !important;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.15);
        -moz-box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.15);
        box-shadow:0px 3px 10px 0px rgba(0,0,0,0.15);
    }

    .row-path {
        @extend %bg-tertiary;
        overflow: hidden;
        width: 100%;
        padding: 1.5rem;
    }

    ul.path {
        float: left;
    }

    ul.path li {
        @extend %text-secondary;
        float: left;
        line-height: 1.5rem;
    }


    ul.path .path-arrow {
        width: 0.625rem;
        height: 0.625rem;
        display: inline-block;
        margin: 0 0.625rem;
    }

    ul.path .path-arrow svg {
        @extend %fill-secondary;
        width:100%;
        height:100%;
    }


    ul.path li:last-child:after {
        display: none;
    }

    .row-path-right {
        float: right;
    }

    .row-path-right>a {
        float: right;
        margin-left: 0.75rem;
    }

    .row-path .search-result {
        float: right;
        line-height: 1.5rem;
    }

    ul.path a {
        width: 1.25rem;
        display: inline-block;
        vertical-align: middle;
    }

    ul.path .path-home {
        background-size: 100%;
    }

    ul.path .path-search {
        background: url(/image/search.svg) no-repeat scroll left top;
        background-size: 100%;
        cursor: text;
    }

    .row-path:after {
        content: '';
        clear: both;
    }

    /*slim version*/
    #slim.row-path {
        position: fixed;
        z-index: 10;
        top: -3.75rem;
        left: 0;
        padding: 1rem 1.5rem;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.15);
        -moz-box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.15);
        box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.15);
    }

    @include narrow {
        #slim.row-path {
            display: none;
        }

        ul.path {
            display: block;
            padding:0 .5rem .5rem .5rem;
            float:none;
        }

        ul.path a {
            float:none;
            display: inline-block;
            vertical-align: top;
        }

        ul.path li {
            float: none;
            display: inline-block;
        }

        .row-path {
            padding:4.3rem .5rem 0.7rem .5rem
        }

        .row-path-right {
            float: none;
            margin-left:-0.7rem; //setting margin-left to the parent cancel the first child margin left in wide screen
            display: flex;
            align-items:center;
            justify-content: space-between;
        }

        .row-path .row-path-btn p {
            display: none;
        }

        .row-path .row-path-btn {
            padding: .5rem;
            height: auto;
        }

        .row-path-right .system-btn>div {
            width: 1.25rem;
            height: 1.25rem;
            margin: 0;
        }

        .row-path-right .search-result {
            float: none;
            line-height: 2.5rem;
            padding-left: .5rem;
        }

    }

    .right-element {
        display:inline-block;
        vertical-align:top;
        margin-left:0.75em;
    }


</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Breadcrumb.vue